module.exports = __webpack_public_path__ + "static/media/Animal Farm Chapter 1.c79636ac.mov";